import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  getStoreList (params) {
    return axios.post(global.CMC_BASE + '/store/findAllStore', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/mmc/store.js